

















import { Component, Mixins, Inject } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { DataModules } from "@/store/modules/data";
import { ITag } from "@/models/tags";
import { ILeadProviderData } from "@/models/providers/lead";

@Component({
  components: {
    "tags-provider": () =>
      import("@/components/app/global/tags/tagsProvider.vue"),
    "tags-view": () => import("@/components/app/global/tags/tagsView.vue")
  }
})
export default class LeadTags extends Mixins(RequestPromises) {
  // Inject

  @Inject({ from: "leadProvider" })
  public readonly $leadProvider!: () => ILeadProviderData;

  // Computed

  public get $leadData() {
    return this.$leadProvider();
  }

  public get lead() {
    return this.$leadData.lead;
  }

  public get activeTagIds() {
    return this.lead.tags.map(t => t.id);
  }

  // Methods

  public availableFilterPredicate(tag: ITag): boolean {
    return tag.brand_id === this.lead.brand_id;
  }

  public assignTags(tagIds) {
    return this.$store.dispatch(`data/${DataModules.LEADS}/assignTags`, {
      id: this.lead.id,
      tagIds
    });
  }

  public async syncTags(tags: ITag[]) {
    if (!this.$userCan("attach_lead_tag")) {
      this.$buefy.toast.open({
        message: this.$t("_sentence.permission_denied") as string,
        type: "is-danger"
      });
    }

    try {
      await this.assignTags(tags.map(i => i.id));
      this.updateTagsInStoredObject(tags);

      this.$buefy.toast.open({
        message: this.$t("_sentence.tags_updated") as string
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }

  public removeTagFromLeadObject(tag: ITag) {
    this.updateTagsInStoredObject(
      this.$_.filter(this.lead.tags, t => t.id !== tag.id)
    );
  }

  public updateTagsInStoredObject(tags: ITag[]) {
    return this.$store.commit(`data/replaceData`, {
      data: {
        ...this.lead,
        ...{
          tags
        }
      },
      scope: this.$leadData.scope,
      storeModule: DataModules.LEADS
    });
  }

  public async unassignTag(tag) {
    if (!this.$userCan("attach_lead_tag")) {
      this.$buefy.toast.open({
        message: this.$t("_sentence.permission_denied") as string,
        type: "is-danger"
      });
    }

    let tagIds = this.lead.tags.map(t => t.id);
    tagIds = this.$_.filter(tagIds, id => id !== tag.id);

    try {
      await this.assignTags(tagIds);
      this.removeTagFromLeadObject(tag);

      this.$buefy.toast.open({
        message: this.$t("_sentence.tag_unassigned") as string
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }
}
